import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

const Logo = () => (
  <div className="flex flex-col items-start gap-2">
    <img
      src="/BUY iT Logo.png"
      alt="BUY iT"
      className="h-10 w-auto"
    />
    <span className="text-[24px] font-extrabold text-[#19C463]">BUY iT</span>
  </div>
);

const AdminLoginScreen = () => {
  const [loginId, setLoginId] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(null);
  const isActive = useMemo(() => loginId.trim().length > 0, [loginId]);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!isActive || loading) return;
    setLoading(true);
    setMessage("");
    setSuccess(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ adminId: loginId.trim() }),
      });
      const data = await response.json();
      setMessage(data.message);
      setSuccess(data.success);
      setTimeout(() => setMessage(""), 2000);
      if (data.success && data.token) {
        localStorage.setItem("adminToken", data.token);
        navigate("/vendor-section", { state: { loginSuccess: data.message } });
      }
    } catch (err) {
      setMessage("Network error. Please try again.");
      setSuccess(false);
      setTimeout(() => setMessage(""), 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full overflow-x-auto bg-[#F1F3F2]">
      {message && (
        <div
          className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 px-6 py-3 rounded-lg shadow-lg text-sm font-semibold animate-fadeInOut ${
            success ? "bg-[#19C463] text-white" : "bg-red-500 text-white"
          }`}
          style={{ minWidth: "220px", textAlign: "center", letterSpacing: "0.5px" }}
        >
          {message}
        </div>
      )}
      <div className="mx-auto flex min-h-screen min-w-[600px] w-full">
        <section className="flex w-1/2 flex-col justify-center bg-[#F1F3F2] px-12 py-12">
          <Logo />

          <div className="mt-10 flex flex-col items-start">
            <h1 className="text-2xl font-semibold text-gray-900">Admin Login</h1>
            <p className="mt-3 text-sm text-gray-600 text-left">
              Monitor deliveries, track orders, and manage platform operations.
            </p>
          </div>

          <div className="mt-8 space-y-4">
            <label className="block text-sm font-medium text-gray-700" htmlFor="login-id">
              Login ID
            </label>
            <div className="flex flex-col items-start gap-3">
              <input
                id="login-id"
                type="text"
                value={loginId}
                onChange={(e) => setLoginId(e.target.value)}
                placeholder="Enter your login ID"
                className="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-900 outline-none transition focus:border-[#19C463] focus:ring-1 focus:ring-[#19C463]"
              />
              <button
                type="button"
                className="text-xs font-semibold text-[#19C463] hover:underline whitespace-nowrap"
              >
                Forgot ID?
              </button>
            </div>

            <button
              type="button"
              disabled={!isActive || loading}
              onClick={handleLogin}
              className={`w-full rounded-lg py-3 text-sm font-semibold transition-colors ${
                isActive && !loading
                  ? "bg-[#19C463] text-white hover:bg-[#14a352]"
                  : "cursor-not-allowed bg-[#D9D9D9] text-gray-500"
              }`}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </div>
        </section>

        <section
          className="h-screen w-1/2 bg-[#F1F3F2]"
          style={{
            backgroundImage: "url('/Rectangle 3350.png')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          aria-label="Admin login illustration"
        />
      </div>
    </div>
  );
};

export default AdminLoginScreen;
